/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
export var application = {
    parameterPath: [
        "options",
        "application"
    ],
    mapper: {
        serializedName: "application",
        type: {
            name: "String"
        }
    }
};
export var endpoint = {
    parameterPath: "endpoint",
    mapper: {
        required: true,
        serializedName: "Endpoint",
        defaultValue: '',
        type: {
            name: "String"
        }
    },
    skipEncoding: true
};
export var imageData = {
    parameterPath: "imageData",
    mapper: {
        required: true,
        serializedName: "imageData",
        type: {
            name: "Stream"
        }
    }
};
export var projectId = {
    parameterPath: "projectId",
    mapper: {
        required: true,
        serializedName: "projectId",
        type: {
            name: "Uuid"
        }
    }
};
export var publishedName = {
    parameterPath: "publishedName",
    mapper: {
        required: true,
        serializedName: "publishedName",
        type: {
            name: "String"
        }
    }
};
//# sourceMappingURL=parameters.js.map